const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSort(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5686 10H6.43137C5.82555 10 5.52265 10 5.38238 10.1198C5.26068 10.2237 5.19609 10.3797 5.20865 10.5392C5.22312 10.7231 5.43731 10.9373 5.86568 11.3657L7.93431 13.4343C8.13232 13.6323 8.23133 13.7313 8.34549 13.7684C8.44591 13.8011 8.55409 13.8011 8.65451 13.7684C8.76867 13.7313 8.86768 13.6323 9.06568 13.4343L9.06569 13.4343L11.1343 11.3657C11.5627 10.9373 11.7769 10.7231 11.7914 10.5392C11.8039 10.3797 11.7393 10.2237 11.6176 10.1198C11.4774 10 11.1744 10 10.5686 10Z",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43137 6H10.5686C11.1744 6 11.4774 6 11.6176 5.8802C11.7393 5.77626 11.8039 5.62033 11.7914 5.46077C11.7769 5.27688 11.5627 5.06269 11.1343 4.63432L9.06569 2.56569C8.86768 2.36768 8.76867 2.26867 8.65451 2.23158C8.55409 2.19895 8.44591 2.19895 8.34549 2.23158C8.23133 2.26867 8.13232 2.36768 7.93432 2.56568L7.93431 2.56569L5.86569 4.63431C5.43731 5.06269 5.22312 5.27688 5.20865 5.46077C5.19609 5.62033 5.26068 5.77626 5.38238 5.8802C5.52265 6 5.82555 6 6.43137 6Z",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon_sort.9cb9b54cd22bf44d1a9668a9a6d425ff.svg";
export { ForwardRef as ReactComponent };